import React, { useState } from "react";
import "./financialsInfo.css";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { saveAsDraft } from "../RoofSelection/roofFunction";
import { useSelector } from "react-redux";
import InfoContainer from "./infoContainer";
import { ProjectApi } from "../../../apis";

// Chart imports
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend
);

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.backgroundColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

export default function FinancialsInfo({ emptyValues }) {
  const navigate = useNavigate();
  const ProjectRouter = ProjectApi();
  const [draftLoader, setDraftLoader] = useState(false);
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);
  const user = conUser?.user;

  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofDetail = quantityInfo?.roofData || [];

  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  let et = roofInfo?.value?.financialAnalysis?.et
    ? Number(roofInfo.value.financialAnalysis.et)
    : 0;
  let maintenceCost = roofInfo?.value?.financialAnalysis?.maintenceCost
    ? Number(roofInfo.value.financialAnalysis.maintenceCost)
    : 0;
  let TPC = roofInfo?.value?.financialAnalysis?.tpc
    ? Number(roofInfo.value.financialAnalysis.tpc) + maintenceCost
    : 0 + maintenceCost;
  const aeci = roofInfo?.value?.financialAnalysis?.aeci
    ? parseFloat(roofInfo.value.financialAnalysis.aeci)
    : 0;
  let expTariff = roofInfo?.value?.financialAnalysis?.exportTriff
    ? parseFloat(roofInfo.value.financialAnalysis.exportTriff)
    : 0;
  const aetIncrease = roofInfo?.value?.financialAnalysis?.aetIncrease
    ? parseFloat(roofInfo.value.financialAnalysis.aetIncrease)
    : 0;
  const roiYears = roofInfo?.value?.financialAnalysis?.roiYears || 20;
  const currency = roofInfo?.value?.financialAnalysis?.currency || "PKR";
  // Enhancement In ROI CHart by Irtaza

  let kWhGen = [];
  for (let j = 0; j < 12; j++) {
    let val = 0;
    for (let i = 0; i < roofDetail.length; i++) {
      const element = roofDetail[i].actualGeneration;
      val += element[j];
    }
    kWhGen.push(val);
  }
  // financialAnalysis yearly calculation
  let yearlySave = [];
  let financialAnalysis = [];
  let remainingTPC = TPC;
  for (let i = 1; i <= roiYears; i++) {
    let consumeUnit = [];
    let exportUnit = [];
    let newKWhGen = [];
    for (let j = 0; j < 12; j++) {
      let monthGen = kWhGen[j];
      if (i > 1) {
        monthGen = kWhGen[j] - kWhGen[j] * 0.0055;
      }
      newKWhGen.push(monthGen);
      const monthUnit = roofInfo.value.financialAnalysis[month[j]];
      if (monthGen > monthUnit) {
        consumeUnit.push(monthUnit);
        exportUnit.push(monthGen - monthUnit);
      } else {
        consumeUnit.push(monthGen);
        exportUnit.push(0);
      }
    }

    if (i > 1) {
      et = Number((et + et * (aeci / 100)).toFixed(2));
      expTariff = Number(
        (expTariff + expTariff * (aetIncrease / 100)).toFixed(2)
      );
    }
    const yearConUnit = Object.values(consumeUnit).reduce(
      (sum, val) => sum + val,
      0
    );
    const yearExpUnit = Object.values(exportUnit).reduce(
      (sum, val) => sum + val,
      0
    );
    const expSave = yearExpUnit * expTariff;
    const conSave = yearConUnit * et;
    const yearSave = expSave + conSave;
    if (i === 1) {
      remainingTPC = yearSave - TPC;
    } else {
      remainingTPC = remainingTPC + yearSave;
    }

    yearlySave.push(yearSave);
    financialAnalysis.push(remainingTPC);
    kWhGen = newKWhGen;
  }

  const totalSave = Object.values(yearlySave).reduce(
    (sum, val) => sum + val,
    0
  );
  const ROIPERCENTAGE = Number(((totalSave / roiYears / TPC) * 100).toFixed(2));

  let givenData = {
    ROI: financialAnalysis,
  };
  let neg = givenData.ROI.map((item, index) => {
    if (item < 0) {
      return item;
    }
    return null;
  });
  let pos = givenData.ROI.map((item, index) => {
    if (item > 0) {
      return item;
    }
    return null;
  });

  let options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 13 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 14,
          },
          display: true,
          text: "Year", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 13 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 14,
          },
          display: true,
          text: `ROI (${currency})`, // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  const generateLabels = (limit) => {
    return Array.from({ length: limit }, (_, i) => (i + 1).toString());
  };

  let state = {
    data: {
      labels: generateLabels(roiYears),
      datasets: [
        {
          stack: "Stack 0",
          label: `Recovery (${currency})`,
          backgroundColor: "#FF7C1B",
          data: neg,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
        {
          stack: "Stack 0",
          label: `Profit (${currency})`,
          backgroundColor: "#045097",
          data: pos,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };

  // Chart Calculations

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleNextPage = () => {
    if (
      !(parseFloat(roofInfo.value.financialAnalysis.aetIncrease) > 0) ||
      !(roofInfo.value.financialAnalysis.tpc > 0) ||
      !(roofInfo.value.financialAnalysis.et >= 0) ||
      !(roofInfo.value.financialAnalysis.aeci > 0)
    ) {
      alert(
        "First complete the finacial section info before going to Design page in the process"
      );
      return false;
    } else {
      navigate("/summary");
    }
  };

  return (
    <>
      <div className="financialInfoContainer">
        <div className="mainInfoBox">
          <InfoContainer emptyValues={emptyValues}></InfoContainer>
          <div className="mapContainer">
            <div className="heading-Container">
              <h1>Return on Investment</h1>

              <div className="dataSpam">
                <h2>ROI : </h2>
                <span>{ROIPERCENTAGE.toFixed(1)} %</span>
              </div>
            </div>
            {/* Sohaib Analytics*/}
            <div className="analyticsGraph">
              <Bar options={options} data={state.data} />
              {/* <div style={{ width: "99%", height: "99%", backgroundColor: "blue" }} /> */}
            </div>
            <div className="chart-ball-text-container">
              {chartBallText(state.data.datasets)}
            </div>
            {/* Sohaib Analytics*/}
          </div>
        </div>
        <div className="containerButton">
          <div className="rightButton">
            <Link to="/electrical">
              <button className="backButton">
                <i className="bi bi-chevron-double-left"></i> Back
              </button>
            </Link>
          </div>
          <div className="rightButton">
            <button onClick={handleShow}>Save as Draft</button>
            <button className="nextButton" onClick={() => handleNextPage()}>
              Next <i className="bi bi-chevron-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Discard Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                ProjectRouter,
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
